module.exports = __webpack_public_path__ + "static/media/service-icon-03.12153268.gif";